export default {"src":"/_next/static/media/play-store.28157d76.svg","height":57,"width":215,"blurWidth":0,"blurHeight":0};